import React from 'react';
import styles from '.././styles.module.scss';
import {AnnouncementItems} from '../consts/types';
import {sendAnalyticsMonitor} from '../../../utils/monitoring';
import {Dialog, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {texts} from '../data/v24texts';
import {DialogContent} from './DialogContent';
import {Footer} from './Footer';
import {ModernTooltip} from '../../../components/Common/Tooltip/ModernTooltip';

interface AnnouncementWelcomDialogPrpos {
    welcomeAnnouncement: AnnouncementItems;
    onClose: () => void;
    onForward: () => void;
}
export const AnnouncementWelcomeDialog = (props: AnnouncementWelcomDialogPrpos) => {
    const {welcomeAnnouncement, onClose, onForward} = props;
    const {content, title, additionalContent, monitoring, linkText, linkUrl, lottieContent} =
        welcomeAnnouncement;
    const forwardBtnText = texts.nextBtn;
    const backwardsBtnText = texts.cancelBtn;

    const handleConfirmBtn = () => {
        if (monitoring?.forwardBtn) {
            sendAnalyticsMonitor(monitoring.forwardBtn);
        }
        onForward();
    };

    const handleBackBtn = () => {
        if (monitoring?.backwardBtn) {
            sendAnalyticsMonitor(monitoring.backwardBtn);
        }
        onClose();
    };

    const handleClose = () => {
        if (monitoring?.closeBtn) {
            sendAnalyticsMonitor(monitoring.closeBtn);
        }
        onClose();
    };

    return (
        <Dialog
            size="small"
            width={640}
            isOpen={true}
            closeIcon={
                <ModernTooltip position="top" tooltip={texts.closeTooltip}>
                    <Icon icon={PriorityIcon.closeSmall} />
                </ModernTooltip>
            }
            componentClasses={styles.dialog}
            onClose={handleClose}
            content={
                <DialogContent
                    linkText={linkText}
                    linkUrl={linkUrl}
                    isWelcomePage={true}
                    content={content}
                    title={title}
                    additionalContent={additionalContent}
                    lottieContent={lottieContent}
                />
            }
            footer={
                <Footer
                    dotsCounter={0}
                    curPageIndex={0}
                    isWelcomePage={true}
                    handleConfirmBtn={handleConfirmBtn}
                    handleBackBtn={handleBackBtn}
                    forwardBtnText={forwardBtnText}
                    backwardsBtnText={backwardsBtnText}
                />
            }
        />
    );
};
